<div class="header-cell-container" (click)="onClick($event)">
  <div class="logo-label-container">
    <div class="logo-wrapper">
      <img class="brand-logo" [src]="brand.icon" (error)="onIconError($event)" />
      <span class="color-dot" [style.background-color]="brand.color"></span>
    </div>
    <span class="brand-label">{{ brand.label }}</span>
  </div>
  <div>
    <img [ngClass]="['sort-arrow', this.sort.direction]" [src]="'svg/sort-arrow.svg' | assetVersion"
      (error)="this.onImgError($event)">
  </div>
</div>